import React from "react";
import { RecentComment } from "./RecentComment";
import { v4 as uuidv4 } from "uuid";
export const RecentCommentsList = ({ recentComments,postId }) => {
  return (
    <div className="flex flex-col gap-2">
      {recentComments.map((comment) => {
        return <RecentComment comment={comment} postId={postId} key={uuidv4()} />;
      })}
    </div>
  );
};
